import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FAQ } from '@umss/shared/data-access';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  private readonly apiUrl = '/api/support';

  constructor(private http: HttpClient) { }

  getFaqs(): Observable<FAQ[]> {
    return this.http.get<FAQ[]>(`${this.apiUrl}/faq`);
  }

  getContactInfo(): Observable<{ email: string; phone: string }> {
    return this.http.get<{ email: string; phone: string }>(`${this.apiUrl}/contact-info`);
  }

  sendChatbotQuery(query: string): Observable<{ response: string }> {
    return this.http.post<{ response: string }>(`${this.apiUrl}/chatbot-query`, { query });
  }
}
